import React from 'react';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { reduxForm, formValueSelector, change } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';
import GenericSelection from '../Common/GenericSelection';
import { SALES_ORDER_DROPDHIP_URL, MOBILE_SALES_ORDER_SHIPPINGINFO_URL } from '../../actions/url';
import { updateMSOFormInitialValues } from '../../actions/sales_actions';

const styles = {
  modal: {
    width: '50%',
    height: '350px',
    // marginLeft: '-15%',
  },
  container: {
    display: 'flex',
    // alignItems: 'center',
    flexDirection: 'column',
    // justifyContent: 'space-between',
  },
  input: {
    border: '1px solid black',
    marginLeft: '20px',
    width: '190px',
    padding: '2px',
    borderRadius: '5px',
  },
  col: {
    marginTop: '20px',
  },
};

class DropshipModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      shippingInfo: props.initialValues ? props.initialValues.Shipping : {},
      errMsg: null,
    };
  }

  saveShippingAddress = () => {
    this.setState({
      loading: true,
    });
    axios.put(
      MOBILE_SALES_ORDER_SHIPPINGINFO_URL,
      this.state.shippingInfo,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
    ).then((res) => {
      this.props.updateMSOFormInitialValues(this.state.shippingInfo);
      this.props.change('salesOrderForm', 'Shipping', this.state.shippingInfo);
      this.setState({
        loading: false,
        errMsg: null,
      });
      this.props.onClose();
    })
      .catch((err) => {
        this.setState({
          loading: false,
          errMsg: 'Something wrong with the provided shipping information, please make sure all fields are filled and accurate',
        });
      });
    // this.props.updateShippingAddress()

    // const { selectedVendorId } = this.state;
    // const { salesOrderId } = this.props;
    // if (!selectedVendorId) {
    //   alert('Please enter a vendor.');
    //   return;
    // }
    // this.setState({
    //   loading: true,
    // });
    // axios.post(`${SALES_ORDER_DROPDHIP_URL}${salesOrderId}`, {
    //   vendor_id: selectedVendorId,
    // }, {
    //   headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    // }).then((response) => {
    //   const { purchase_order_id } = response.data;
    //   window.location.pathname = `/purchaseOrder/${purchase_order_id}`;
    // }).catch(() => {
    //   alert('Internal Server Error. Please try again.');
    // });

  }
  // { "CustomerDetail_id": 2, "AddressName": "", "Country": "United States", "State": "CA", "City": "Berkeley", "Street": "334 w garvey ave,undefined", "Zip": "94701", "lat": 34.062674, "lng": -118.127149, "FirstName": "tim", "LastName": "tim", "Telephone": "6263829999", "Cellphone": "", "Fax": "", "Email": "", "Note": "", "Type": "Shipping", "IsDefault": false, "IsDeleted": false, "Customer_id": 20, "Address": "333 w garvey ave" }
  updateShippingInfo = (evt, field) => {
    this.setState({
      errMsg: null,
      shippingInfo: {
        ...this.state.shippingInfo,
        [field]: evt.target.value,
      },
    });
  };

  render() {
    const {
      isVisible,
      onClose,
      updateShippingAddress,
    } = this.props;
    return (
      <SkyLightStateless
        dialogStyles={styles.modal}
        isVisible={isVisible}
        onCloseClicked={onClose}
      >
        <div style={styles.container}>
          <div style={{ width: '100%' }}>
            <h2 style={{ margin: '0 auto' }}>Shipping Information Edit</h2>
          </div>
          <Row>
            <Col sm={4} style={styles.col}>
              <label >
                <Translate value="first_name" />
              </label>
              <input type="text" style={styles.input} value={this.state.shippingInfo.FirstName} onChange={(e) => this.updateShippingInfo(e, 'FirstName')} />
            </Col>
            <Col sm={4} style={styles.col}>
              <label >
                <Translate value="last_name" />
              </label>
              <input type="text" style={styles.input} value={this.state.shippingInfo.LastName} onChange={(e) => this.updateShippingInfo(e, 'LastName')} />
            </Col>
            <Col sm={4} style={styles.col}>
              <label >
                <Translate value="phone" />
              </label>
              <input type="text" style={styles.input} value={this.state.shippingInfo.Telephone} onChange={(e) => this.updateShippingInfo(e, 'Telephone')} />
            </Col>
          </Row>
          <Row>
            <Col sm={6} style={styles.col}>
              <label >
                <Translate value="street" />
              </label>
              <input type="text" style={styles.input} value={this.state.shippingInfo.Street} onChange={(e) => this.updateShippingInfo(e, 'Street')} />
            </Col>
            <Col sm={6} style={styles.col}>
              <label >
                <Translate value="city" />
              </label>
              <input type="text" style={styles.input} value={this.state.shippingInfo.City} onChange={(e) => this.updateShippingInfo(e, 'City')} />
            </Col>
          </Row>
          <Row>
            <Col sm={6} style={styles.col}>
              <label >
                <Translate value="state" />
              </label>
              <input style={styles.input} type="text" value={this.state.shippingInfo.State} onChange={(e) => this.updateShippingInfo(e, 'State')} />
            </Col>
            <Col sm={6} style={styles.col}>
              <label >
                <Translate value="zip_code" />
              </label>
              <input type="text" style={styles.input} value={this.state.shippingInfo.Zip} onChange={(e) => this.updateShippingInfo(e, 'Zip')} />
            </Col>
          </Row>
          <div style={{ marginTop: 50, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <p style={{ color: 'red' }}>{this.state.errMsg}</p>
            <Button
              bsStyle="primary"
              onClick={this.saveShippingAddress}
              disabled={this.state.loading}
              style={{ float: 'right' }}
            >
              <Translate value="save" />
            </Button>
          </div>
        </div>
      </SkyLightStateless>
    );
  }
}

const mapStateToProps = state => ({
  vendors: state.vendors.all,
});

export default connect(mapStateToProps, { updateMSOFormInitialValues, change })(DropshipModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/ShippingInfoFormModal.jsx